import { MarketSegmentQueries } from '@/graphql/queries/marketSegment.queries'
import { MarketSegment } from '@/types/MarketSegment'

import { useGraphql } from './useGraphql'

const useMarketSegments = () => {
  const currentUserQuery = useGraphql<{ marketSegments: MarketSegment[] }>(
    MarketSegmentQueries.QUERY_KEY,
    MarketSegmentQueries.getMarketSegmentList(),
    {},
  )
  return currentUserQuery
}

export default useMarketSegments
